import "../App.css";

function Projects() {
  return (
    <div className="center-box">
      <div className="work-box">
        <div>
          <h3 className="work-heading">Projects</h3>

          <h6>
            Stadium Tour Management System — Python,SQLite
            <em>
              {" "}
              <u>
                <a
                  href="https://github.com/MitanshiKshatriya/Stadium-tour-management-system"
                  target="_blank"
                  rel="noreferrer"
                >
                  link
                </a>
              </u>
            </em>
          </h6>

          <p className="work-desc">
            - A python and sqlite based project for easing the task of a stadium
            tour manager. Uses various sql query statements. Applies genetic
            algorithms to find out the best possible route for the tour.
          </p>

          <h6>
            100DaysOfCodeLogger — NodeJS, ReactJS, MongoDB
            <em>
              {" "}
              <u>
                <a
                  href="https://github.com/MitanshiKshatriya/100daysOfCodeLogger-server"
                  target="_blank"
                  rel="noreferrer"
                >
                  link
                </a>
              </u>
            </em>
          </h6>

          <p className="work-desc">
            - A webapp for logging 100daysOfCode progress. It also allows the
            user to maintain an overall list of goals they would like to achieve
            in the 100DaysOfCode challenge.
          </p>

          <h6>
            IEEE WIE VIT website — HTML,CSS,JavaScript
            <em>
              {" "}
              <u>
                <a
                  href="https://ieeewievit.org/"
                  target="_blank"
                  rel="noreferrer"
                >
                  link
                </a>
              </u>
            </em>
          </h6>

          <p className="work-desc">
            - Built an informative page for IEEE WIE VIT with animation using
            vanilla JavaScript
          </p>

          <h6>
            Mood Player — Python,SpotifyAPI
            <em>
              {" "}
              <u>
                <a
                  href="https://github.com/MitanshiKshatriya/mood-player"
                  target="_blank"
                  rel="noreferrer"
                >
                  link
                </a>
              </u>
            </em>
          </h6>

          <p className="work-desc">
            - Built a mood player using CNN, OpenCV and SpotifyAPI. Used CNN to
            detect mood of a person and change playing song on Spotify according
            to the mood detected.
          </p>

          <h6>
            Encryption/Decryption using CRT — Python
            <em>
              {" "}
              <u>
                <a
                  href="https://github.com/MitanshiKshatriya/encryption-decryption-using-CRT"
                  target="_blank"
                  rel="noreferrer"
                >
                  link
                </a>
              </u>
            </em>
          </h6>

          <p className="work-desc">
            - Implemented{" "}
            <a
              style={{ color: "steelblue" }}
              href="http://www.ripublication.com/ijaerspl2019/ijaerv14n2spl_38.pdf"
              target="_blank"
              rel="noreferrer"
            >
              this
            </a>{" "}
            research paper to encrypt and decrypt using only Chinese Remainder
            Theorem (CRT) and using RSA with CRT.
          </p>

          <h6>
            Taylor Swift Api — NodeJS
            <em>
              {" "}
              <u>
                <a
                  href="http://taylorswiftapi.herokuapp.com/"
                  target="_blank"
                  rel="noreferrer"
                >
                  link
                </a>
              </u>
            </em>
          </h6>

          <p className="work-desc">
            - A random taylor swift lyric generator made using NodeJS and
            deployed on Heroku
          </p>
        </div>
      </div>
    </div>
  );
}

export default Projects;
